import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function SeoContentSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <article>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6 md:mb-8">
            {t('seo.title')}
          </h2>

          <div className="space-y-5 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              {t('seo.paragraph1')}
            </p>
            <p>
              {t('seo.paragraph2')}
            </p>
            <p>
              {t('seo.paragraph3')}
            </p>
          </div>

          <div className="mt-8 md:mt-10">
            <Link
              to="/yoybuy-sheet-guide"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm md:text-base font-semibold hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('seo.read_more')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </article>
      </div>
    </section>
  );
}